import { Box, ButtonBase, useTheme } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import { AdminPanelSettingsOutlined, SpaOutlined } from "@mui/icons-material";

// ----------------------------------------------------------------------

const OPTIONS = [
  { key: "plataforma", label: "Plataforma", path: "/dashboard/app", Icon: SpaOutlined },
  { key: "admin", label: "Admin", path: "/adm", Icon: AdminPanelSettingsOutlined },
] as const;

/** Alterna entre o app da plataforma e o backoffice (/adm). Renderizar apenas para admins. */
export default function EnvSwitcher() {
  const theme = useTheme();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const active = pathname.startsWith("/adm") ? "admin" : "plataforma";

  return (
    <Box
      sx={{
        display: "flex",
        gap: 0.5,
        p: 0.5,
        borderRadius: "12px",
        backgroundColor: theme.palette.brand.switcherBg,
      }}
    >
      {OPTIONS.map(({ key, label, path, Icon }) => {
        const isActive = key === active;
        return (
          <ButtonBase
            key={key}
            aria-pressed={isActive}
            onClick={() => !isActive && navigate(path)}
            sx={{
              flex: 1,
              gap: 0.75,
              py: "9px",
              borderRadius: "9px",
              fontFamily: theme.typography.fontFamily,
              fontSize: "12.5px",
              fontWeight: isActive ? 600 : 500,
              color: isActive ? theme.palette.brand.switcherActiveText : theme.palette.brand.navItemText,
              backgroundColor: isActive ? theme.palette.brand.switcherActiveBg : "transparent",
              transition: "all .14s",
            }}
          >
            <Icon sx={{ fontSize: 14 }} />
            {label}
          </ButtonBase>
        );
      })}
    </Box>
  );
}
